import { render, staticRenderFns } from "./tab-expired.vue?vue&type=template&id=227baaf7&"
import script from "./tab-expired.vue?vue&type=script&lang=js&"
export * from "./tab-expired.vue?vue&type=script&lang=js&"
import style0 from "./tab-expired.vue?vue&type=style&index=0&id=227baaf7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports